import api from './core/api';
import {
  AbstractService,
  ApiResponse,
  BaseEntity,
} from './core/AbstractService';

export type PromotionType = 'PERCENTAGE' | 'FIXED_AMOUNT' | 'FREE_SHIPPING';
export type PromotionScope =
  | 'ALL'
  | 'FIRST_ORDER'
  | 'SPECIFIC_PRODUCTS'
  | 'SPECIFIC_CATEGORIES';
export type PromotionStatus = 'active' | 'expired' | 'scheduled' | 'inactive';

export interface Promotion extends BaseEntity {
  name: string;
  code?: string;
  type: PromotionType;
  value: number;
  minOrderAmount?: number;
  maxDiscountAmount?: number;
  usageLimit?: number;
  usageCount: number;
  perUserLimit: number;
  startsAt: string;
  expiresAt?: string;
  isActive: boolean;
  appliesTo: PromotionScope;
  targetIds?: string[];
  autoApply: boolean;
  description?: string;
  status: PromotionStatus;
}

export interface PromotionStats {
  totalUsage: number;
  totalDiscountGiven: number;
  uniqueUsers: number;
}

class PromotionService extends AbstractService<Promotion> {
  constructor() {
    super('/admin/promotions');
  }

  async getStats(id: string | number): Promise<ApiResponse<PromotionStats>> {
    const response = await api.get<ApiResponse<PromotionStats>>(
      `${this.basePath}/${id}/stats`
    );
    return response.data;
  }
}

export default new PromotionService();
